<template>
    <div v-if="show_form">
        <form id="settings_form">
            <div id="message_div"></div>
            <kt-row>
                <kt-col lg="12" md="12" sm="12" style="margin-top: 15px">
                   <default-psp-setting :settings="general_settings" ></default-psp-setting>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="4" md="4" sm="12" style="margin-top: 15px">
                    <div class="custom-control custom-switch">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="need_authentication"
                                name="need_authentication"
                                v-model="general_settings.need_authentication"
                        >
                        <label class="custom-control-label" for="need_authentication">
                            {{ $t('label.ipg_link_authentication_status') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-form-action class="mt-2">
                <button style="margin-top: 25px" class="btn btn-md btn-success btn-wide"
                        @click.prevent="updateSettings"
                        type="submit" id="change_settings_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from "jquery"
import {i18n} from '@/plugins/i18n'
import {mapGetters} from "vuex"
import {KTApp} from '@/plugins/core/app'
import {pardakhtShakhsiService} from '@/common/api.service'
import defaultPspSetting from './default-psp-setting'


export default {
    components :{
      'default-psp-setting' : defaultPspSetting
    },
    computed: {},
    mounted() {
        pardakhtShakhsiService.getGeneralSettings().then(response => {
            this.general_settings = response.data.data
            this.show_form = true
        }).finally(()=>{
            this.afterDispatch()
        })
    },
    data() {
        return {
            is: 0,
            general_settings: {},
            show_form: false,
        }
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        updateSettings() {
            let btn = $('#change_settings_btn')
            let form = $('#settings_form')
            form.validate({
                rules: {
                    payment_method: {
                        required: true
                    },
                }
            })

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            pardakhtShakhsiService.updateGeneralSettings(this.general_settings).then(response => {
                this.showMsg(form, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>